import React from 'react';

import arrowTitleLeft from "../../../images/aiReport/arrow-title-left.png";
import arrowTitleRight from "../../../images/aiReport/arrow-title-right.png";

import "./index.less"

const ModuleTitle = (props) => {
    const {text = "", title='', enText = ''} = props;
    return (
        <div className="moduleTitle">
            <div className="moduleContent">
                <p>{enText}</p>
                <div className="content-text">
                    <img src={arrowTitleLeft}/>
                    <span>{text}</span>
                    <img src={arrowTitleRight}/>
                </div>
            </div>
            {title && <div className="moduleTitleText">{title}</div>}
        </div>
    )
};

export default ModuleTitle;